import React, { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import $ from 'jquery';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import bannerimage from "../../Assests/images/home_images/contact-banner-desktop.jpg"
// import mobilebanner from "../../Assests/images/home_images/contact-banner-mobile.jpg"

window.jQuery = window.$ = $;
require('jquery-nice-select');

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const Contact = () => {
  const selectRef = useRef();

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNumber: '',
    interestedIn: '',
    message: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [captcha, setCaptcha] = useState('');

  useEffect(() => {
    $(selectRef.current).niceSelect();

    $(selectRef.current).on('change', (e) => {
      const selectedValue = e.target.value;
      setFormData((prevData) => ({
        ...prevData,
        interestedIn: selectedValue,
      }));
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        interestedIn: selectedValue ? '' : 'Please select an option',
      }));
    });

    return () => {
      $(selectRef.current).niceSelect('destroy');
      $(selectRef.current).off('change');
    };
  }, []);
  const handleCaptchaChange = (value) => {
    setCaptcha(value);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    let errors = { ...formErrors };

    switch (id) {
      case 'fullName':
        errors.fullName = value.trim()
          ? (/^[a-zA-Z\s]+$/.test(value) ? '' : 'Name should contain only alphabetic characters')
          : 'This field is required';
        break;
      case 'email':
        errors.email = value.trim()
          ? (isValidEmail(value) ? '' : 'Invalid email address')
          : 'This field is required';
        break;
      case 'mobileNumber':
        errors.mobileNumber = value.trim()
          ? (/^\d{10}$/.test(value) ? '' : 'Mobile number must be 10 digits')
          : 'This field is required';
        break;
      case 'message':
        errors.message = value.trim()
          ? (value.trim().split(/\s+/).length <= 200 ? '' : 'Message should be within 200 words')
          : 'This field is required';
        break;
      case 'interestedIn':
        errors.interestedIn = value ? '' : 'Please enter the address';
        break;
      default:
        break;
    }

    setFormData({ ...formData, [id]: value });
    setFormErrors(errors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const requiredFields = ['fullName', 'email', 'mobileNumber', 'interestedIn', 'message'];
    const emptyField = requiredFields.find(field => !formData[field]);

    if (emptyField || !captcha) {
      const errorMessages = {};
      requiredFields.forEach(field => {
        errorMessages[field] = formData[field] ? '' : `Please fill in the "${fieldLabels[field]}" field.`;
      });
      errorMessages.captcha = !captcha ? 'Please verify you are not a robot.' : '';
      setFormErrors(errorMessages);
      setSubmitting(false);
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_SEND_CHANNEL_PARTNER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...formData, captcha }),
      });

      if (!response.ok) {
        throw new Error('Failed to send email');
      }

      const data = await response.json();

      if (data && data.success) {
        setFormData({
          fullName: '',
          email: '',
          mobileNumber: '',
          interestedIn: '',
          message: '',
        });
        setCaptcha('');
        setFormErrors({ submit: 'Thank You, your Email has been sent. Our Team will reach out to you shortly.' });
      } else {
        setFormErrors({ submit: data.message || 'Email could not be sent!' });
      }
    } catch (error) {
      console.error('Error:', error);
      setFormErrors({ submit: 'Sorry for the inconvenience, Something Went Wrong, Please try again later.' });
    } finally {
      setSubmitting(false);
      setShowPopup(true);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const fieldLabels = {
    fullName: 'Full Name',
    email: 'Email Address',
    mobileNumber: 'Mobile Number',
    interestedIn: 'Interested In',
    message: 'Message',
  };

  const { fullName, email, mobileNumber, interestedIn, message } = formData;

  return (
    <section className="section-top-map style-2 ">
      {/* <div className="wrap-map">
        <LazyLoadImage src={bannerimage} alt="banner-image " className="contact-banner-image desktop-banner" />
        <LazyLoadImage src={mobilebanner} alt="banner-image " className="contact-banner-image mobile-banner" />


      </div> */}

      <div >
        <div className="tf-container">
          <div className="row">
            <div className="col-12">
              <form
                id="contactform"
                className="form-contact"
                onSubmit={handleSubmit}
              >
                <div className="heading-section" style={{ textAlign: "center" }}>
                  <h2 className="title">Channel Partner Registration</h2>
                  <p className="text-1">
                  Fill out the registration form below
                  </p>
                </div>

                <div className="cols">
                  <fieldset>
                    <label htmlFor="name">Name:</label>
                    <input
                      type="text"
                      id="fullName"
                      className="form-control"
                      value={fullName}
                      placeholder="Your name"
                      onChange={handleChange}
                      required
                    />

                    {formErrors.fullName && <p className="error">{formErrors.fullName}</p>}
                  </fieldset>
                  <fieldset>
                    <label htmlFor="email">Email:</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      value={email}
                      placeholder="Email"
                      onChange={handleChange}
                      required
                    />
                    {formErrors.email && <p className="error">{formErrors.email}</p>}
                  </fieldset>
                </div>

                <div className="cols">
                  <fieldset className="phone">
                    <label htmlFor="phone">Phone number:</label>
                    <input
                      type="tel"
                      id="mobileNumber"
                      placeholder="Your phone number"
                      name="phone"
                      className="form-control"
                      value={mobileNumber}
                      required
                      onChange={handleChange}
                    />
                    {formErrors.mobileNumber && <p className="error">{formErrors.mobileNumber}</p>}
                  </fieldset>
                  <div className="select custom-select-dropdown">
                    <label className="text-1 fw-6 mb-12">Address:</label>
                    <fieldset>
                     
                      <input
                      type="text"
                       id="interestedIn"
                      className="form-control"
                       value={interestedIn}
                      placeholder="Address"
                      onChange={handleChange}
                      required
                    />
                      {formErrors.interestedIn && <p className="error">{formErrors.interestedIn}</p>}
                    </fieldset>
                  </div>
                </div>

                <fieldset>
                  <label htmlFor="message">Your Message:</label>
                  <textarea
                    name="message"
                    cols="30"
                    rows="10"
                    placeholder="Message"
                    id="message"
                    value={message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </fieldset>
                <div className="form-row captch pb-5">
                  <div className='form-col'>
                    <ReCAPTCHA
                      sitekey="6LdLpMgqAAAAAOyy8PH_bkCGPDi4Xm1EBUAo0zTO"
                      onChange={handleCaptchaChange}
                      className='captch'
                    />
                    {formErrors.captcha && <p className="error">{formErrors.captcha}</p>}
                  </div>
                </div>
                {formErrors.message && <p className="error">{formErrors.message}</p>}
                <button type="submit" disabled={submitting} className="tf-btn bg-color-primary fw-7 pd-8">
                  {submitting ? 'Submitting...' : 'Contact our experts'}
                </button>
              </form>
              {formErrors.submit && <p className="submitError">{formErrors.submit}</p>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;